import { render, staticRenderFns } from "./VehicleRequestIdentification.vue?vue&type=template&id=d3f2d3d8&"
import script from "./VehicleRequestIdentification.vue?vue&type=script&lang=js&"
export * from "./VehicleRequestIdentification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports